import { useUserPermissions } from "../../../../frontend/SignIn/UserPermissionsContext";

export const useCanUploadProfile = () => {
  const { userPermissions } = useUserPermissions();
  return (userPermissions || []).includes("Adviser Support");
};
